import { useQuery } from "@tanstack/react-query";
import { getJson } from "../client";

export function useTags(options = {}) {
  return useQuery({
    queryKey: ["tags"],
    queryFn: async () => {
      const fields = [
        "id",
        "name",
        "translations.languages_code",
        "translations.text",
      ].join(",");

      const params = {
        fields,
        sort: "name",
        limit: "1000", // Get all tags
      };

      const json = await getJson("/items/Tags", params);
      return json?.data || [];
    },
    staleTime: 300_000, // 5 minutes
    refetchOnWindowFocus: false,
    ...options,
  });
}

export default useTags;
